import ConsentManager from "./consent/ConsentManager";

const requiredConsentTypes = ['functionality_storage', 'analytics_storage', 'personalization_storage'];
ConsentManager.silentlyRequireConsentToContinue(requiredConsentTypes)
    .then(() => {
        window.Trengo = window.Trengo || {};
        window.Trengo.key = '6gkhOGS4NQY4v2XDpEzS';
        (function (d, script, t) {
            script = d.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.src = 'https://static.widget.trengo.eu/embed.js';
            d.getElementsByTagName('head')[0].appendChild(script);
        }(document));
    });

window.chatWidget = {
    open() {
        ConsentManager.requireConsentToContinue(requiredConsentTypes).then(() => {
            // Watch for the chat widget Api to become available
            const interval = setInterval(() => {
                if (window.Trengo.Api && window.Trengo.Api.Widget) {
                    clearInterval(interval);
                    window.Trengo.Api.Widget.open('chat');
                }
            }, 150);
        })
    }
};

